import { Fragment } from "react";
import { blocks, type Inline } from "./richtext.ts";

// Free text (notes, an item's notes) as paragraphs, line breaks, bullets, bold and links. With `links`
// false, a link shows as its words only: inside something that's one control as a whole (a research tile),
// there's nothing else to press.
export function RichText({ text, className, links = true }: { text: string; className?: string; links?: boolean }) {
  return (
    <div className={`tm-rich${className ? ` ${className}` : ""}`}>
      {blocks(text).map((b, i) =>
        b.kind === "list" ? (
          // biome-ignore lint/suspicious/noArrayIndexKey: blocks have no identity beyond their order
          <ul key={i} className="tm-rich-block tm-rich-list">
            {b.items.map((item, j) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: as above
              <li key={j}>
                <Pieces pieces={item} links={links} />
              </li>
            ))}
          </ul>
        ) : (
          // biome-ignore lint/suspicious/noArrayIndexKey: as above
          <p key={i} className="tm-rich-block">
            {b.lines.map((line, j) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: as above
              <Fragment key={j}>
                {j > 0 && <br />}
                <Pieces pieces={line} links={links} />
              </Fragment>
            ))}
          </p>
        ),
      )}
    </div>
  );
}

function Pieces({ pieces, links }: { pieces: Inline[]; links: boolean }) {
  return pieces.map((p, i) =>
    p.kind === "bold" ? (
      // biome-ignore lint/suspicious/noArrayIndexKey: pieces have no identity beyond their order
      <strong key={i} className="tm-rich-bold">
        {p.text}
      </strong>
    ) : p.kind === "link" && links ? (
      // biome-ignore lint/suspicious/noArrayIndexKey: as above
      <a key={i} className="tm-rich-link" href={p.url} target="_blank" rel="noreferrer noopener">
        {p.text}
      </a>
    ) : (
      // biome-ignore lint/suspicious/noArrayIndexKey: as above
      <Fragment key={i}>{p.text}</Fragment>
    ),
  );
}
